import { render, staticRenderFns } from "./UnknownError.vue?vue&type=template&id=03f0f48c&scoped=true&lang=pug&"
import script from "./UnknownError.vue?vue&type=script&lang=js&"
export * from "./UnknownError.vue?vue&type=script&lang=js&"
import style0 from "./UnknownError.vue?vue&type=style&index=0&id=03f0f48c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f0f48c",
  null
  
)

export default component.exports